module.exports = "<div class=\"pp-overlay pp-gameplay-pause-overlay\" data-bind=\"visible: pauseScreenVisible\">\n\n    <div class=\"pp-overlay__background\"></div>\n\n    <div class=\"pp-overlay__modal pp-overlay__modal__auto-size\">\n\n        <h1>Game Paused</h1>\n\n        <button data-bind=\"click: resumeGame\" class=\"btn secondary\">Continue</button>\n        <button data-bind=\"click: quitToMenu\" class=\"btn primary\">Quit</button>\n\n    </div>\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/ts/screens/gameplay/pause-menu/PauseOverlay.html
// module id = 42
// module chunks = 0